import { render, staticRenderFns } from "./CronometroComPalavra.vue?vue&type=template&id=2646d072&scoped=true&"
import script from "./CronometroComPalavra.vue?vue&type=script&lang=js&"
export * from "./CronometroComPalavra.vue?vue&type=script&lang=js&"
import style0 from "./CronometroComPalavra.vue?vue&type=style&index=0&id=2646d072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646d072",
  null
  
)

export default component.exports